import request from '../../utils/request'

// 获取字典类型对应的数据
export function getDictDataByDictType(dictType) {
  return request({
    url: `/system/dictData/getDictData/${dictType}`,
    method: 'get'
  })
}
